module.exports = __webpack_public_path__ + "img/WHITE_GECANTON.ee870377.svg";